import React from 'react'

export const Spacer = () => {
    return <span className="flex-grow"></span>
}
